<template>
  <EmdFormGroup
    :label="$t('recipients.create.description')"
    :state="getState($v.recipient.description)"
    :feedbacks="feedbacks($v.recipient.description)"
  >
    <EmdInput
      @input="() => $v.recipient.description.$touch()"
      v-model="recipient.description"
      name="description"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'
export default {
  name: 'DescriptionInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    description: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>
